import { ReactNode } from 'react';

type Meta = {
  touched?: boolean,
  modifiedSinceLastSubmit?: boolean,
  error?: ReactNode,
  warning?: ReactNode,
  submitError?: ReactNode,
};

export const FormStateSpecification = {
  error: (meta: Meta = {}) => {
    return !!(meta.touched && (meta.error || (!meta.modifiedSinceLastSubmit && meta.submitError)));
  },
  warning: (meta: Meta = {}) => {
    return !!(meta.touched && meta.warning);
  },
};
